/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { MetaData } from "../Courses/GetAllRequests";
import { Book } from "../../types/types";
export type StudentsDTO = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  img_url: string;
  phone: string;
  country: string;
  password: string;
  confirmPassword: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  lastCountry: string;
};
type address = {
  city: string;
  floor: string;
  state: string;
  street: string;
  country: string;
  landing: string;
  building: string;
  apartment: string;
};
type bookData = {
  student: StudentsDTO;
  adress: address;
  book: Book;
  shipping_status: string;
  payment_status: string;
  id: string;
};
interface RequestsData {
  bookTransactions: bookData[];
  metaData: MetaData;
}

interface RequestsResponse {
  data?: RequestsData;
  error?: ApiError;
}

interface GetRequestsParams {
  page: number;
  limit: number;
  firstName?: string;
  shipping_status?: string;
  payment_status?: string;
  phone?: string;
}

export const GetBooksRequests = async ({
  page,
  limit,
  firstName,
  shipping_status,
  payment_status,
  phone,
}: GetRequestsParams): Promise<RequestsResponse> => {
  try {
    const response = await axios.get(`/transaction/books`, {
      params: {
        page,
        limit,
        firstName,
        shipping_status,
        payment_status,
        phone,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
